import LocalImage from "@/components/image/LocalImage";

//#region [Props]
type DownArrowProps = {
    className?: string;
    alt: string;
};
//#endregion

//#region [Component]
export default function DownArrow({ className, alt }: DownArrowProps) {
    return <LocalImage className={className} src="/Down.svg" width={23.857809} height={13.857612} alt={alt} />;
}
//#endregion

//#region [Styles]

//#endregion